module.exports = __webpack_public_path__ + "assets/img/1813.f7b52b6c.svg";